module.exports = require("json-stable-stringify");